
<template>
  <div class="main">
    <div>
      <a-button type="primary" class="mr10" @click="click_creBuildBt(1)">创建新楼</a-button>
      <a-button type="" class="mr10" @click="clickBatchBedInfo()">批量添加位置</a-button>
      <a-button type="" class="mr10" :href="this.$store.state.baseUrl + '/excelModel/批量位置模版.xlsx'">批量位置模板下载</a-button>
	  <a-button type="" class="mr10" @click="clickAddSosBtn()">绑定/解绑按钮</a-button>
      <div style="float:right;">
        <a-input-search v-model="keyWord" placeholder="请输入SN码" style="width: 155px" @search="onSearch" />
      </div>
      <a-modal v-model="exportShow" footer="" title="批量添加位置" :width="400">
        <a-form>
          <a-form-item>
            <!-- <a-upload name="file" :multiple="false" action="http://192.168.1.195:9527/api/v3/radar/uploadFile" @change="handleUpload"> -->
            <!-- <a-upload name="file" :multiple="false" action="https://dev.qingleitech.com/api/v3/radar/uploadFile" @change="handleUpload"> -->
            <a-upload name="file" :multiple="false" action="api/v3/radar/uploadFile" @change="handleUpload">
              <div class="upFileWrap" v-if="upState == 0">
                <p class="fileLeftPath"> </p>
                <a-button type="primary" v-if="upState == 0">选择文件</a-button>
              </div>
              <div class="upFileWrap" v-if="upState == 1 || upState == 2">
                <p class="fileLeftPath">{{localFileName}}</p>
                <div class="sczIng" v-if="upState == 1">上传中</div>
                <a-button type="primary" v-if="upState == 2">重新上传</a-button>
              </div>
            </a-upload>

            <div class="xjDataWrap">
              <!-- 检测中 -->
              <div v-if="excelState == 0">
                <div>正在校检 {{localFileName}}</div>
                <div>共......条数据</div>
              </div>
              <!-- 检测完成 -->
              <div v-if="excelState == 1">
                <div>检测完成 {{localFileName}}</div>
                <div v-if="importExcelCode == 0">
                  <!-- 数据正确 -->
                  <div v-if="importExcelData.checkFlag">共检测到<span style="color:#1890FF;"> {{importExcelData.validNum}} </span>条有效数据</div>
                  <!-- 数据错误 -->
                  <div v-if="!importExcelData.checkFlag">
                    <div>
                      共检测到
                      <span style="color:#1890FF;">{{importExcelData.totalNum}}</span>
                      条数据，其中
                      <span style="color:#1890FF;">{{importExcelData.validNum}}</span>
                      条有效数据
                    </div>
                    <div v-if="importExcelData.formatErrorNum != 0">{{importExcelData.formatErrorNum}}条问题数据：楼-层-房-位置名称不能有特殊符号且最多支持20个字符</div>
                    <div v-if="importExcelData.buildingLimitNum != 0">{{importExcelData.buildingLimitNum}}条问题数据：每个机构最多支持100幢楼</div>
                    <div v-if="importExcelData.floorLimitNum != 0">{{importExcelData.floorLimitNum}}条问题数据：每幢楼最多支持30个楼层</div>
                    <div v-if="importExcelData.roomLimitNum != 0">{{importExcelData.roomLimitNum}}条问题数据：每个楼层最多支持30个房间</div>
                    <div v-if="importExcelData.bedLimitNum != 0">{{importExcelData.bedLimitNum}}条问题数据：每个房间最多支持5个监测位</div>
                    <div v-if="importExcelData.invalidNum != 0">{{importExcelData.invalidNum}}条问题数据：无效数据</div>
                    <div v-if="importExcelData.snBindTen != 0">{{importExcelData.snBindTen}}条问题数据：sn码已经在其他机构绑定</div>
                    <div v-if="importExcelData.snBindBed != 0">{{importExcelData.snBindBed}}条问题数据：sn码已经绑定到其他位置</div>
                    <div v-if="importExcelData.snBindC != 0">{{importExcelData.snBindC}}条问题数据：sn码已经在C端绑定，导入会把关系拉到当前机构</div>
                    <div v-if="importExcelData.snNoEnter != 0">{{importExcelData.snNoEnter}}条问题数据：sn未录入</div>
                    <div v-if="importExcelData.snRepeat != 0">{{importExcelData.snRepeat}}条问题数据：sn重复录入</div>
										<div v-if="importExcelData.bedNameRepeat != 0">{{importExcelData.bedNameRepeat}}条问题数据：床位名称重复</div>
                  </div>
                </div>
                <!-- 模板错误 -->
                <div v-if="importExcelCode == 1" style="color:#FF4D4F">{{isImportFalseMsg}}</div>
              </div>
            </div>
            <div class="aBtWrap" v-if="upState == 0" style="height:50px;"></div>
            <div class="aBtWrap" v-if="upState != 0">
              <a-button @click="exportShow = false">取消</a-button>
              <a-button class="ml10" type="primary" @click="downProblemData()" v-if="importExcelData && !importExcelData.checkFlag">下载问题数据</a-button>
              <a-button class="ml10" type="primary" @click="importExcel(true)" :loading="exLoading" v-if="excelState == 1" :disabled="importExcelCode == 1 ? true : false">确定导入</a-button>
            </div>
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
    <!-- 有数据 -->
    <div class="posListWrap" v-if="buildingV3VoPage && buildingV3VoPage.total != 0">
      <div class="posList" :key="index" v-for="(item,index) in buildingV3VoPage.records" @click="goBuild(item)">
        <div class="tc buildName" :style="{height:buildNameHeiTop}">{{item.name}}</div>
        <div class="buildCont" v-if="item.floorNum != 0">
          <div>共<span class="color1890ff">{{item.floorNum}}</span>层</div>
          <div><span class="color1890ff">{{item.roomNum}}</span>个房间</div>
          <div><span class="color1890ff">{{item.bedNum}}</span>个床位</div>
          <div><span class="color1890ff">{{item.toiletNum}}</span>个卫生间</div>
        </div>
        <div class="buildCont" v-if="item.floorNum == 0">
          <div><span class="color1890ff">去建层</span></div>
        </div>
        <div class="iconAll">
          <a-icon type="form" class="tableIcon"  @click.stop="click_creBuildBt(0,item)"/>
          <img src="../../assets/icon_trashCan_nor.png" alt="" @click.stop="cli_del_icon(item)">
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <a-pagination :pageSize="pageSize" v-model="pageNum" :total="buildingV3VoPage.total" @change="pageChange" show-less-items style="text-align: center; margin-top: 20px" :hideOnSinglePage="true" />
    <!-- 无数据 -->
    <div class="comNoData" v-if="buildingV3VoPage && buildingV3VoPage.total == 0">
      <img src="../../assets/iconBuilding.png" alt="">
      <div class="ml10">暂未创建楼，可以先尝试创建您的第一座楼</div>
    </div>
    <!-- 创建楼弹窗 -->
    <a-modal :title="creBuildTan_type == 1 ? '创建新楼' : '修改楼名'" :width="400" v-model="creBuildTan" footer="">
      <div class="radarTanWrap">
        <div class="pb10">最多支持20位字符，不支持特殊符号</div>
        <input :class="['inputList',item.inputListBorRed ? 'inputListBorRed' : '']" type="text" maxlength="20" placeholder="请输入楼名" :key="index" v-for="(item,index) in buildList" v-model="item.buildName"  @keyup="inputChangeHandle(item)">
        <div class="addJcy" @click="creBuild()" v-if="creBuildTan_type == 1">
          <img class="jiaImg" src="../../assets/jia.png" alt="">
          <div>一幢楼</div>
        </div>
      </div>
      <div style="margin-top:20px;text-align: right;">
        <el-button @click="creBuildTan = false">取消</el-button>
        <el-button type="primary" @click="sureCreBuild" v-if="creBuildTan_type == 1">创建</el-button>
        <el-button type="primary" @click="sureCreBuild" v-if="creBuildTan_type == 0">修改</el-button>
      </div>
    </a-modal>

    <!-- 创建楼到数量限制弹窗 -->
    <a-modal title="" :width="400" v-model="buildMoreCountTan" footer="">
      <p class="delTips pt50">
        <a-icon type="exclamation-circle" />
        每个机构最多支持100幢楼，需要先删除楼才能创建新楼
      </p>
      <div style="margin-top:20px;text-align: right;">
        <el-button type="primary" @click="buildMoreCountTan = false">知道了</el-button>
      </div>
    </a-modal>

    <!-- 删除楼弹窗 -->
    <a-modal title="" :width="400" v-model="delBuildTan" footer="">
      <p class="delTips pt50" v-if="!item.hasRelation">
        <a-icon type="exclamation-circle" />
        即将删除楼，您确定要删除吗？
      </p>
      <p class="delTips pt50" v-if="item.hasRelation">
        <a-icon type="exclamation-circle" />
        即将删除楼，已经建立的位置和设备关系也将解除，您确定要删除吗？
      </p>
      <p class="delTips colorff4d4f" v-if="item.hasConsumer">注意：本次删除包含C端用户的设备，这个操作只会删除在当前机构的位置绑定关系</p>
      <div style="margin-top:20px;text-align: right;">
        <el-button @click="delBuildTan = false">取消</el-button>
        <el-button type="primary" @click="tan_cli_del_icon()">删除</el-button>
      </div>
    </a-modal>

	<!-- 绑定/解绑按钮 - 第一步 -->
	<a-modal :width="500" v-model="isShowBindSosBtnListAlert" :footer="null" title="绑定/解绑按钮" :centered="true" :afterClose="handleClose">
		<div style="width: 100%;">
			<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #262626; line-height: 20px;">请在一台上线的设备附近，按一下要绑定/解绑的按钮</div>
			<div style="background: #F7F8FA; border-radius: 4px; margin-top: 8px; padding-left: 16px; display: flex; flex-direction: column;  max-height: 652px;">
				<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8C8C8C; line-height: 20px; margin-top: 15px; height: 20px;"  :style="{marginBottom: (nearbyButtonList && nearbyButtonList.length > 0) ? '11px' : '15px'}">{{ loadingText }}</div>
        <div v-for="item in nearbyButtonList" :key="item.sosId || item.snCode" style="height: 43px; display: flex; flex-direction: column;">
					<div style="height: 1px; background: #262626; opacity: 0.05;"></div>
					<div style="display: flex; flex-direction: row; flex: 1; align-items: center; justify-content: space-between;">
						<div style="display: flex;">
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8C8C8C; line-height: 20px;">{{ item.snCode || '' }}</div>
							<div v-if="item.isBind" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8C8C8C; line-height: 20px; margin-left: 10px;">绑定在</div>
							<div v-if="item.isBind" class="anotherName" style="position: relative; overflow: visible;">
								<div v-if="item.isBind" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8C8C8C; line-height: 20px; margin-left: 10px; white-space: nowrap; text-overflow: ellipsis; width: 220px; overflow: hidden;">{{ item.bedName || '' }}</div>
								<div v-if="item.bedName && item.bedName.length > 12" class="anotherNameJt" :style="{ top: '20px'}">{{ item.bedName || '' }}</div>
							</div>
						</div>
						<div @click="goToUnBindSosBtnWithLocation(item)" v-if="item.isBind" style="width: 60px; height: 26px; border-radius: 16px; border: 1px solid rgba(24, 144, 255, 0.2); font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #1890FF; line-height: 22px; display: flex; align-items: center; justify-content: center; margin-right: 16px; cursor: pointer;">解绑</div>
						<div @click="goToBindSosBtnWithLocation(item)" v-if="!item.isBind" style="width: 60px; height: 26px; border-radius: 16px; border: 1px solid rgba(24, 144, 255, 1); font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #FFFFFF; line-height: 22px; display: flex; align-items: center; justify-content: center; margin-right: 16px; background-color: rgba(24, 144, 255, 1); cursor: pointer;">绑定</div>
					</div>
				</div>
			</div>
			<div v-if="nearbyButtonData && nearbyButtonData.sosBindVoPage && nearbyButtonData.sosBindVoPage.pages > 1" style="height: 32px; margin-top: 20px;">
				<!-- 分页 -->
				<a-pagination :pageSize="pageSizeSos" v-model="pageNumSos" :total="nearbyButtonData.sosBindVoPage.total" @change="pageChangeSos" show-less-items style="text-align: center;" :hideOnSinglePage="true" />
			</div>
		</div>
	</a-modal>

    <!-- 绑定 - 第二步 - 选择位置 -->
	<a-modal v-model="isShowBindSosBtnSelectAlert" footer="" :width="400" :title="'绑定按钮'">
		<el-form>
			<div>
				<!-- 批量独有树形数据 -->
				<div style="">
					<div style="display: flex; flex-direction: row; margin-top: -10px; margin-bottom: 10px;">
						<div style="height: 22px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #262626; line-height: 22px;">正在绑定</div>
						<div v-if="currentSosBtnItem" style="height: 22px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #262626; line-height: 22px; margin-left: 10px;">{{ currentSosBtnItem.snCode || '' }}</div>
					</div>
					<a-tree-select ref="myTestRef" v-if="treeData && treeData.length > 0" v-model="bindSosBtnSelectedLocationArr" style="" :tree-data="treeData"
						treeCheckable :treeDefaultExpandAll="true" :replace-fields="{ value2: 'bindSosBtnSelectedLocationArr', value: 'objId', title: 'objName' }"
						:show-checked-strategy="treeStrategy" placeholder="请选择需要绑定的位置"
						:dropdown-style="{ maxHeight: '192px', overflow: 'auto', maxWidth: '100px' }" @change="testChange">
					</a-tree-select>
				</div>
			</div>
			<div style="margin-top:20px;text-align: right;">
				<el-button @click="bindSosBtnCancel">取消</el-button>
				<el-button type="primary" @click="bindSosBtnSure">确定</el-button>
			</div>
		</el-form>
	</a-modal>

	<!-- 解绑 - 第二步 -->
	<a-modal title="" :width="400" v-model="isShowUnBindSosBtnAlert" footer="">
        <div style="display: flex; margin-top: 46px; padding-bottom: 16px;">
			<img style="width: 16px; height: 16px; margin-top: 2px; margin-right: 11px;" src="../../assets/icon_alert_warning.png" alt="">
			<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #262626; line-height: 20px;">确定解绑当前按钮？</div>
		</div>
        <div style="margin-top:20px;text-align: right;">
          <el-button @click="isShowUnBindSosBtnAlert = false">取消</el-button>
          <el-button type="primary" @click="unbindBtn()">解绑</el-button>
        </div>
    </a-modal>


	<!--  -->
	<!-- <a-modal
      title="添加床位"
      :visible="isShowBindSosBtnSelectAlert"
      :maskClosable="false"
      :width="500"
      @cancel="bindSosBtnOff"
      :footer="null"
      class="bedModel"
    >
      <a-tree
        v-if="treeData.length"
        v-model="checkedKeys"
        checkable
        :default-expand-all="autoExpandParent"
        :auto-expand-parent="autoExpandParent"
        :tree-data="treeData"
        style="margin-top: 14px"
      />
      <div class="treeBtn">
        <a-button style="margin-right: 10px" @click="bindSosBtnOff">取消</a-button>
        <a-button type="primary" @click="bindSosBtnSure" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal> -->

  </div>
</template>

<script>

import { createGlobalStompScope } from '@/utils/stomp';

import { TreeSelect } from 'ant-design-vue';
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

export default {
  components: {},
  watch: {
    
  },
  data() {
    return {
      keyWord: "",
      pageNum: 1,
      pageSize: 24,
      buildingV3VoPage: '',           //楼分页数据
      creBuildTan: false,             //创建楼弹窗
      buildList: [{ buildName: "" }],
      buildMoreCountTan: false,       //创建楼到数量限制弹窗
      delBuildTan: false,             //删除楼弹窗
      item: '',                       //当前操作的操作的item
      creBuildTan_type: '',           //1创建楼 0修改楼
      buildNameHeiTop: '',            //buildName高度


      // 批量导入床位信息部分
      fileList: [], //必须用这个字段，官网需要
      upState: 0, //上传文件状态 0选择文件 1上传中 2重新上传

      // 检测数据 || 导入数据部分
      importExcelData: null, // WEB管理员上传批量上传用户信息Excel
      
      excelState: -1, //检测中0 检测完成1
      importExcelCode: -1, //检测接口返回的code0 模板错误 code1数据错误，数据正确
      isImportFalseMsg: null, //模板错误返回字段

      exportShow: false,
      exLoading: false,
      // 批量导入床位信息部分end

	  // 是否显示绑定/解绑SOS按钮弹窗
	  isShowBindSosBtnListAlert: false,
	  // 附近按钮列表数据
	  nearbyButtonData: null,
	  // 附近按钮列表数组
	  nearbyButtonList: null,
	  loadingText: '',
	  loadingTextInterval: null,
	  // 是否显示绑定选择弹窗
	  isShowBindSosBtnSelectAlert: false,
	  checkedKeys: [],
	  autoExpandParent: true,
	  treeData: [],
	  loading: false,
	  bindSosBtnSelectedLocationArr: [],
	  treeStrategy: SHOW_PARENT,

	  isShowUnBindSosBtnAlert: false,

	  pageNumSos: 1,
      pageSizeSos: 14,
	  currentSosBtnItem: null,

	  stompClientStatus: null,
	  socketData: null
    };
  },
  created() {},
  mounted() {
    this.getBuildingPage()    //获取楼分页数据
  },
  methods: {
	inputChangeHandle(e){
		e.buildName = e.buildName.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g,'')
	},
	testChange(value, label, extra) {
		// @change="testChange" :maxTagCount="1" @search="testSearch"
		this.updateTreeData(value);
	},
	clickAddSosBtn() {
		this.getSosBtnList(1);
		this.getSocketStatus();
		this.isShowBindSosBtnListAlert = true;
		this.loadingTextInterval = setInterval(() => {
			if (this.loadingText && this.loadingText.length >= 6) {
				this.loadingText = '';
			} else {
				this.loadingText = this.loadingText + '.';
			}
		}, 300);
	},
	handleClose() {
		if (this.loadingTextInterval) {
			clearInterval(this.loadingTextInterval);
			this.loadingTextInterval = null;
			this.loadingText = '';
		}
		if (this.stompClientStatus != null) {
			this.stompClientStatus.disconnect();
			this.stompClientStatus = null;
		}
	},
	// 点击解绑 - 某个按钮
	goToUnBindSosBtnWithLocation(item) {
		this.currentSosBtnItem = item;
		this.isShowUnBindSosBtnAlert = true;
	},
	// 点击绑定 - 某个按钮
	goToBindSosBtnWithLocation(item) {
		this.bindSosBtnSelectedLocationArr = [];
		this.currentSosBtnItem = item;
		this.isShowBindSosBtnSelectAlert = true;
		this.getTreeData();
	},
	// 确定绑定按钮
	bindSosBtnSure() {
		if (this.bindSosBtnSelectedLocationArr && this.bindSosBtnSelectedLocationArr.length > 0) {
			this.bindBtn(this.bindSosBtnSelectedLocationArr[0]);
		} else {
			this.$message.error('请选择位置');
		}
	},
	// 取消绑定按钮
	bindSosBtnCancel() {
		this.isShowBindSosBtnSelectAlert = false;
	},
	// 接口 - 绑定按钮
	bindBtn(bedId) {
		let params = {
			bedId: bedId,
			snCode: this.currentSosBtnItem.snCode,
		}
		this.$post(
			'/api/sos/bind',
			params,
			(res) => {
				if (res.code == 0) {
					this.$message.success(res.msg || '绑定成功');
					this.isShowBindSosBtnSelectAlert = false;
					this.getSosBtnList();
				} else {
					this.$message.error(res.msg || '绑定失败');
				}
			},
			(err) => {
				this.$message.error(err);
			}
		);
	},
	// 接口 - 解绑按钮
	unbindBtn() {
		let params = {
			bedId: this.currentSosBtnItem.bedId,
			sosId: this.currentSosBtnItem.sosId,
		}
		this.$post(
			'/api/sos/unbind',
			params,
			(res) => {
				if (res.code == 0) {
					this.$message.success(res.msg || '解绑成功');
					this.isShowUnBindSosBtnAlert = false;
					this.getSosBtnList();
				} else {
					this.$message.error(res.msg || '解绑失败');
				}
			},
			(err) => {
				this.$message.error(err);
			}
		);
	},
	getSosBtnList(action) {
		let param = {
			pageNum: this.pageNumSos,
			pageSize: this.pageSizeSos
		};
		if (action) {
			param.action = 1;
			this.nearbyButtonList = [];
		}
		this.$get(
			"/api/sos/sosBindPage",
			param,
			(res) => {
				console.log('===', res)
				if (res.code == 0) {
					this.nearbyButtonData = res.data;
					if (res.data && res.data.sosBindVoPage) {
						this.nearbyButtonList = res.data.sosBindVoPage.records || [];
					} else {

					}
				}
			},
			(err) => {
				this.$message.error(err);
			}
		);
	},
	getTreeData() {
		this.$get(
			'/api/sos/getBedTreeList',
			{},
			(res) => {
				if (res.code == 0) {
					if (res.data) {
						this.treeData = this.dealServerTreeData(res.data);
					} else {
					}
				} else {
				}
			},
			(err) => {
				this.$message.error(err);
			}
		);
	},
	// 处理服务器返回的树型结构
	dealServerTreeData(serverData) {
		let data = JSON.parse(JSON.stringify(serverData || []));
		for (let a = 0; a < data.length; a++) {
			data[a].checkable = false;
			if (data[a].children && data[a].children.length > 0) {
				for (let b = 0; b < data[a].children.length; b++) {
					data[a].children[b].checkable = false;
					if (data[a].children[b].children && data[a].children[b].children.length > 0) {
						for (let c = 0; c < data[a].children[b].children.length; c++) {
							data[a].children[b].children[c].checkable = false;
							if (data[a].children[b].children[c].children && data[a].children[b].children[c].children.length > 0) {
								for (let d = 0; d < data[a].children[b].children[c].children.length; d++) {
									data[a].children[b].children[c].children[d].checkable = true;
								}
							}
						}
					}
				}
			}

		}
		return data;
	},
	updateTreeData(objIds) {
		let objId = objIds.length > 0 ? objIds[0] : undefined;
		let data = JSON.parse(JSON.stringify(this.treeData || []));
		for (let a = 0; a < data.length; a++) {
			data[a].checkable = false;
			if (data[a].children && data[a].children.length > 0) {
				for (let b = 0; b < data[a].children.length; b++) {
					data[a].children[b].checkable = false;
					if (data[a].children[b].children && data[a].children[b].children.length > 0) {
						for (let c = 0; c < data[a].children[b].children.length; c++) {
							data[a].children[b].children[c].checkable = false;
							if (data[a].children[b].children[c].children && data[a].children[b].children[c].children.length > 0) {
								for (let d = 0; d < data[a].children[b].children[c].children.length; d++) {
									if (objId) {
										if (data[a].children[b].children[c].children[d].objId == objId) {
											console.log('===111===', data[a].children[b].children[c].children[d].objId)
											data[a].children[b].children[c].children[d].disabled = false;
										} else {
											data[a].children[b].children[c].children[d].disabled = true;
										}
									} else {
										data[a].children[b].children[c].children[d].disabled = false;
									}
								}
							}
						}
					}
				}
			}

		}
		this.treeData = data;
	},
	getSocketStatus() {
		if (this.stompClientStatus != null) {
      this.stompClientStatus.destroy();
			this.stompClientStatus = null;
		}
		let id = this.$getCookie('userInfo').user.tenantId;
    this.stompClientStatus = createGlobalStompScope({
      vm: this,
      name: 'radar-sos-bind',
    });
		// 连接
		console.log('Websocket - sosBindPage - 开始连接 - 1');
    this.stompClientStatus.subscribe('/topic/sosBindPage.' + id, ({ body }) => {
      if (body) {
        console.log('Websocket - sosBindPage - 收到消息 - 2');
        this.socketData = body;
        this.getSosBtnList();
      }
    });
    this.stompClientStatus.connect();
	},
	select_sure() {

	},
    // 获取楼分页数据
    getBuildingPage(){
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$get(
        "/api/v3/building/getBuildingPage",
        param,
        (res) => {
          if (res.code == 0) {
            this.buildingV3VoPage = res.data.buildingV3VoPage;
            this.buildNameHeiTop = 'auto';
            setTimeout(() => {
              this.init_buildNameHeiTop()     //初始化buildName高度动态配置
            }, 0);
            console.log(res);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },

    // 分页
    pageChange(e) {
      console.log(e);
      this.pageNum = e;
      this.getBuildingPage();
    },
	pageChangeSos(e) {
      console.log(e);
      this.pageNumSos = e;
      this.getSosBtnList();
    },

    // 初始化buildName高度动态配置
    init_buildNameHeiTop(){
      let elem = document.querySelectorAll('.buildName');
      let heiTop = 0;
      for(let i = 0;i < elem.length;i++){
        let nowTop = elem[i].getBoundingClientRect().height
        if(nowTop > heiTop){
          heiTop = nowTop
        }
      }
      console.log(heiTop)
      this.buildNameHeiTop = heiTop + 'px'
    },
    // 搜索
    onSearch(e) {
      console.log(e);
      this.$router.push('./searchSnPos?keyWord='+e)
    },
    // 点击创建新楼按钮(type 1创建 0修改)
    click_creBuildBt(type,item){
      this.creBuildTan_type = type; //1创建楼 0修改楼
      if(type == 1){
        if(this.buildingV3VoPage.total < 100){
          this.buildList = [{buildName: ''}];
          this.creBuildTan = true;
        }else{
          this.buildMoreCountTan = true;
        }
      }else if(type == 0){
        this.item = item;     //当前操作的操作的item
        this.buildList = [{buildName: this.item.name}];
        this.creBuildTan = true;
      }
    },
    // +一幢楼
    creBuild() {
      let nowLength = this.buildList.length + this.buildingV3VoPage.total;    //当前一共多少楼
      if(nowLength < 100){
        let buildName = { buildName: "" };
        this.buildList.push(buildName);
      }else{
        this.$message.error("每个机构最多支持100幢楼，需要先删除楼才能创建新楼");
      }
    },
    // 创建新楼弹框内点击确定走创建新楼接口
    sureCreBuild(){
      let isCanGo = 0;    //是否能添加 只要循环里有一个有数据即可添加
      for(let i = 0;i < this.buildList.length;i++){
        if(this.buildList[i].buildName){
          isCanGo = 1
          this.buildList[i].inputListBorRed = false;
        }else{
          this.buildList[i].inputListBorRed = true;
        }
      }
      // this.loading = true;
      if(isCanGo != 1){
        this.$forceUpdate()
        return;
      }
      if(this.creBuildTan_type == 1){             //创建楼
        let buildingNameList = []
        for(let i = 0;i < this.buildList.length;i++){
          if(this.buildList[i].buildName){
            buildingNameList.push(this.buildList[i].buildName)
          }
        }
        let param = {
          buildingNameList: buildingNameList,
        };
        this.$post(
          "/api/v3/building",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.creBuildTan = false;
              this.getBuildingPage()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }else if(this.creBuildTan_type == 0){       //修改楼
        let param = {
          id: this.item.id,
          name: this.buildList[0].buildName,
        }
        this.$put(
          "/api/v3/building",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.creBuildTan = false;
              this.getBuildingPage()
            } else {
              this.$message.error(res.msg);
            }
          },
          (err) => {
            console.log(err);
            this.$message.error(err.msg);
          }
        );
      }
    },
    // 点击删除icon
    cli_del_icon(item){
      console.log(item)
      this.item = item;          //当前操作的操作的item
      this.delBuildTan = true;   //弹窗显示
    },
    // 弹窗内点击删除
    tan_cli_del_icon(){
      let param = {
        hasRelation: this.item.hasRelation,
        id: this.item.id,
      }
      this.$delete(
        "/api/v3/building/delete",
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.delBuildTan = false;
            this.getBuildingPage()
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error(err.msg);
        }
      );
    },
    // 进楼
    goBuild(item){
      this.$router.push({
        path: "./goBuild?buildId=" + item.id + '&buildName=' + item.name,
      });
    },


    // 点击批量导入床位信息
    clickBatchBedInfo() {
      this.exportShow = true;
      this.exLoading = false;

      // 数据初始化
      this.upState = 0;
      this.importExcelData = null;
      this.excelState = -1;
      this.importExcelCode = -1;
      this.isImportFalseMsg = null;
    },
    handleUpload(info) {
      if (info.file.status !== "uploading") {
        // 如果不是excel文件
        if (
          info.file.type !=
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
          info.file.type != "application/vnd.ms-excel"
        ) {
          this.$message.error("文件类型错误，请上传excel类型文件");
          return;
        }
        // 如果不是excel文件end
        this.localFileName = info.file.name; //本地文件名字
        this.upState = 1; //上传中
        this.exFilePath = info.file.response.data.filePath;
        console.log("hello", info.file.response.data.filePath);
      }
      if (info.file.status === "done") {
        // this.$message.success(`${info.file.name} 上传成功`);
        this.upState = 2; //上传成功，重新上传
        this.importExcel(false); //WEB管理员上传批量上传用户信息Excel
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
        this.upState = 0; //上传失败，选择文件
      }
    },
    // WEB管理员上传批量上传用户信息Excel(type走检测false,走上传true)
    importExcel(type) {
      if (type) {
        this.exLoading = true;
      } else {
        this.excelState = 0; //检测中0  检测完成1
      }
      setTimeout((e) => {
        this.$post(
          "/api/v3/building/addBatch",
          {
            filePath: this.exFilePath,
            isImport: type, // 检测false  上传true
          },
          (res) => {
            this.importExcelCode = res.code; //code0 模板错误 code1数据错误，数据正确
            this.excelState = 1; //检测中0  检测完成1
            if (res.code == 0) {
              // 走检测false
              if (!type) {
                this.importExcelData = res.data;
              } else {
                //走导入true
                this.exportShow = false;
                this.$message.success(res.msg);
              }
              this.exLoading = false;
            } else {
              if (!type) {
                //走检测
                this.isImportFalseMsg = res.msg; //模板错误返回字段
              } else {
                //走导入
                this.$message.error(res.msg);
                this.exLoading = false;
              }
            }
          },
          (err) => {
            console.log(err);
            // this.$message.error("服务端发生异常");
            this.exLoading = false;
          }
        );
      }, 500);
    },
    // 点击下载问题数据
    downProblemData() {
      let tenantId = this.importExcelData.tenantId
      window.open(
        this.$store.state.baseUrl +
          "/api/v3/building/downloadProblemData?filePath=" + this.exFilePath + '&tenantId=' + tenantId
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.posListWrap {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  .posList:nth-of-type(8n + 1) {
    margin-left: 3px;
  }
  .posList:hover {
    background: #e6f7ff;
  }
  .posList {
    width: 132px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 20px 10px;
    box-sizing: border-box;
    margin-top: 10px;
    margin-left: 10px;
    cursor: pointer;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    .buildName {
      // height: 63px;
      // height: auto;
      display: flex;
      justify-content: center;
      // align-items: center;
    }
    .buildCont {
      height: 83px;
      text-align: center;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .iconAll {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .tableIcon {
        color: #1890ff;
        font-size: 20px;
        cursor: pointer;
        margin-right: 20px;
      }
    }
  }
}


.upFileWrap {
  width: 350px;
  height: 33px;
  line-height: 33px;
  border: 1px solid #d9d9d9;
  display: flex;
  padding-left: 10px;
}
.fileLeftPath {
  margin-right: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.sczIng {
  width: 74px;
  height: auto;
  background: #ffffff;
  border-radius: 2px;
  text-align: center;
  border-left: 1px solid #d9d9d9;
}
.xjDataWrap {
  line-height: 25px;
}
.aBtWrap {
  margin-top: 10px;
  text-align: right;
}
.ant-form-item {
  margin-bottom: 0;
}
// 隐藏上传时插件自带的列表
::v-deep .ant-upload-list {
  display: none;
}
.tableWrap {
  .ant-btn {
    padding: 0 5px;
  }
}
.lrck_tableWrap {
  padding-top: 30px;
  border-top: 2px dashed #d8d8d8;
  margin-top: 30px;
}

.treeBtn {
  text-align: right;
}

.anotherNameJt{
	font-size: 14px;
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	color: #1F2635;
	line-height: 20px;
	padding: 8px 12px;
	box-sizing: border-box;
	position: absolute;
	top: -28px;
	right: -47%;
	display: none;
	z-index: 1;
	max-width: 231px;
	background: #FFFFFF;
	box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
	border-radius: 2px;
}

.anotherName:hover .anotherNameJt {
	display: block;
}

</style>